import { AuthService } from "./auth-service";

const REACT_APP_DOMAIN = process.env.REACT_APP_DOMAIN;
const axios = require("axios").default;

export class MapService {

  static async getList(params) {
    try {
      const base_url = `${REACT_APP_DOMAIN}/api/map-widget/`;
      const response = await axios.get(base_url, {
        params: params,
        headers: {
          Authorization: `Token ${AuthService.getWpProxyToken()}`,
        },
      });
      //console.log(response);
      return response.data;
    } catch (error) {
      console.error(error);
      return error.response;
      //throw error;
    }
  }

  static async update(id, data) {
    try {
      const base_url = `${REACT_APP_DOMAIN}/api/map-widget/`;
      const response = await axios.put(`${base_url}${id}/`, data, {
        headers: {
          //'Content-Type': 'multipart/form-data',
          Authorization: `Token ${AuthService.getWpProxyToken()}`,
        },
      });
      //console.log(response);
      return response;
    } catch (error) {
      console.error(error.response.data);
      return error.response;
    }
  }

  static async getSections(id, params) {
    try {
      const base_url = `${REACT_APP_DOMAIN}/api/map-widget/`
      const response = await axios.get(`${base_url}${id}/section`, {
        params: params,
        headers: {
          Authorization: `Token ${AuthService.getWpProxyToken()}`,
        },
      });
      // console.log(response);
      return response.data;
    } catch (error) {
      return error.response;
    }
  }

  static async updateSectionPosts(id, section_id, params) {
    try {
      const base_url = `${REACT_APP_DOMAIN}/api/map-widget/`;
      const response = await axios.patch(`${base_url}${id}/section/${section_id}/`,
        {
          title: params.title,
          description: params.description,
          posts_ids: params.posts_ids
        },
        {
          headers: {
            //'Content-Type': 'multipart/form-data',
            Authorization: `Token ${AuthService.getWpProxyToken()}`,
          },
        }
      );
      //console.log(response);
      return response;
    } catch (error) {
      console.error(error.response.data);
      return error.response;
    }
  }

  static async getSingle(id) {
    try {
      const base_url = `${REACT_APP_DOMAIN}/api/map-widget/`
      const response = await axios.get(`${base_url}${id}`, {
        headers: {
          Authorization: `Token ${AuthService.getWpProxyToken()}`,
        },
      });
      // console.log(response);
      return response;
    } catch (error) {
      return error.response;
    }
  }

}
